import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Composant pour remonter automatiquement en haut de page
 * lors du changement de route
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Remonter en haut de page à chaque changement de route
    window.scrollTo({
      top: 0,
      behavior: 'instant' // Instantané pour un changement de page
    });
  }, [pathname]);

  return null; // Ce composant ne rend rien visuellement
};

export default ScrollToTop;
